var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginBut",on:{"click":_vm.goShowMyCenter}},[(_vm.userInfo)?_c('div',{staticClass:"default"}):_vm._e(),_c('span',{staticClass:"loginBut_title"},[_vm._v("用户")])])
}
var staticRenderFns = []

export { render, staticRenderFns }